
import React from 'react';
import { CLIENTS, COLORS } from '../constants';

const Marquee: React.FC = () => {
  return (
    <section className="pt-12 md:pt-16 pb-0 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-20">
        <div className="grid lg:grid-cols-2 gap-6 md:gap-10 items-start mb-12">
          <div className="max-w-xl reveal-item">
            <h2 className="fluid-heading-lg font-bold leading-tight text-[#1E1E1E]">
              Focusing on quality, <br />
              <span className="text-gray-400 font-medium italic">we maintain customer trust</span>
            </h2>
          </div>
          <div className="text-slate-500 text-base md:text-lg leading-relaxed lg:pt-4 max-w-lg reveal-item" style={{ transitionDelay: '0.2s' }}>
            We ensure that every installation we build has strict quality checks. Sustainable solutions for an environmentally friendly and renewable future.
          </div>
        </div>

        <div className="flex flex-wrap justify-center lg:justify-between gap-4 md:gap-8 lg:gap-4 pb-16">
          {CLIENTS.map((client, idx) => (
            <div 
              key={client.name}
              className="group relative w-32 h-32 sm:w-40 sm:h-40 md:w-52 md:h-52 rounded-full bg-[#F2F4F4] hover:bg-white hover:shadow-[0_40px_80px_-15px_rgba(0,0,0,0.12)] transition-all duration-500 flex items-center justify-center p-6 md:p-14 cursor-pointer border border-transparent hover:border-gray-50 reveal-item"
              style={{ transitionDelay: `${0.05 * idx}s` }}
            >
              <div 
                className="w-full h-full text-[#1E1E1E] opacity-100 group-hover:text-[#00D47E] transition-all duration-500 flex items-center justify-center"
              >
                {client.logo}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
